import { createContext } from 'react'

const SnackContext = createContext(
{
    snack       : null,
    closeSnack  : () => null,
    notifySnack : () => null
});

export default SnackContext;